import { formatDob } from "./fictional";

let encoder = null;
async function loadEncoder() {
  if (!encoder) encoder = (await import("qrcode")).default;
  return encoder;
}


export const QR_VERSIONS = { TEXT: "text", SECURE: "secure" };


const BUDGET = { [QR_VERSIONS.TEXT]: 2200, [QR_VERSIONS.SECURE]: 2850 };


const PHOTO_BUDGET = 1800;

const THUMB_W = 32;
const THUMB_H = 40;

const GENDER_CODE = { male: "M", female: "F", other: "T" };

const byteLength = (text) =>
  typeof TextEncoder === "undefined"
    ? text.length
    : new TextEncoder().encode(text).length;

export function maskAadhaar(aadhaar) {
  const digits = String(aadhaar || "").replace(/\D/g, "");
  if (digits.length < 4) return "";
  return `XXXX XXXX ${digits.slice(-4)}`;
}


function buildThumbnail(dataUrl, budget = PHOTO_BUDGET) {
  return new Promise((resolve) => {
    if (!dataUrl || typeof document === "undefined") return resolve(null);

    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = THUMB_W;
        canvas.height = THUMB_H;
        const ctx = canvas.getContext("2d");
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, THUMB_W, THUMB_H);

        const frame = ctx.getImageData(0, 0, THUMB_W, THUMB_H);
        const px = frame.data;
        for (let i = 0; i < px.length; i += 4) {
          const luma = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2];
          px[i] = px[i + 1] = px[i + 2] = luma;
        }
        ctx.putImageData(frame, 0, 0);

        for (const quality of [0.5, 0.4, 0.3, 0.2]) {
          const encoded = canvas.toDataURL("image/jpeg", quality).split(",")[1];
          if (encoded && encoded.length <= budget) return resolve(encoded);
        }
        resolve(null);
      } catch (err) {

        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = dataUrl;
  });
}

const clean = (value) => (typeof value === "string" ? value.trim() : "");

function line(label, value) {
  const text = clean(value);
  return text ? `${label}: ${text.replace(/\s*\n\s*/g, " ")}` : null;
}

export function buildQrPayload(data = {}, thumbnail = null) {
  const head = [
    "Generated by a Govt. valid proof of identity.",
  ];

  const fields = [
    line("Aadhaar", maskAadhaar(data.aadhaar)),
    line("VID", maskAadhaar(data.vid)),
    line("Name", data.name),
    line("NameLocal", data.nameLocal),
    line("DOB", formatDob(clean(data.dob))),
    line("Gender", GENDER_CODE[data.gender] || ""),
    line("Address", data.address),
    line("AddressLocal", data.addressLocal),
  ].filter(Boolean);


  const tail = thumbnail ? [`Photo(jpeg;base64;${THUMB_W}x${THUMB_H})`, thumbnail] : [];

  return [...head, ...fields, ...tail].join("\n");
}


export async function buildSpecimenQr(data = {}, options = {}) {
  const QRCode = await loadEncoder();
  const wanted = options.version === QR_VERSIONS.TEXT
    ? QR_VERSIONS.TEXT
    : QR_VERSIONS.SECURE;

  let thumbnail =
    wanted === QR_VERSIONS.SECURE ? await buildThumbnail(data.photo) : null;


  let payload = buildQrPayload(data, thumbnail);
  if (byteLength(payload) > BUDGET[QR_VERSIONS.SECURE]) {
    thumbnail = null;
    payload = buildQrPayload(data, null);
  }

  const errorCorrectionLevel =
    byteLength(payload) <= BUDGET[QR_VERSIONS.TEXT] ? "M" : "L";

  return QRCode.toDataURL(payload, {
    margin: 0,
    width: 480,
    errorCorrectionLevel,
    color: { dark: "#111111", light: "#ffffff" },
  });
}
